import { createContext } from "react";
export const AxiomAppContext = createContext({});
